import { render, staticRenderFns } from "./MyOrderTurn.vue?vue&type=template&id=f453f32c&scoped=true&"
import script from "./MyOrderTurn.vue?vue&type=script&lang=js&"
export * from "./MyOrderTurn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f453f32c",
  null
  
)

export default component.exports